import React from 'react';

function GuestGreeting() {
  return (
    <h1>Please login.</h1>
  )
}

export default GuestGreeting;
